<template>
  <div class="page-wrapper">
    <DonationManagement @tab="switchTab" v-if="tab_switch == 'management' && $checkPermission('donation')">
    </DonationManagement>
  </div>
</template>
<script>
import DonationManagement from "./DonationManagement.vue";
export default {
  components: {
    DonationManagement,
  },
  data: () => ({
    tab_switch: "management",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "management";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    } else {
      vm.tab_switch = "management";
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "s_donation", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>
